import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_RO.json';
import audios from './ASTROLOGY_AUDIOS_RO.json';

export const ASTROLOGY_DATA_RO: ServiceData = {
  articles,
  audios,
};
